import React from 'react';

import DoacoesShared from '@pages/Private/shared/Doacoes';
import ListPessoasShared from '@pages/Private/shared/ListPessoas';
import EditCadastro from '@pages/Private/shared/EditCadastro';
import Indicadores from '@pages/Private/shared/ListIndicadores';

import Usuarios from '@pages/Private/shared/Usuarios';
import EditarUsuario from '@src/Pages/Private/shared/EditarUsuario';
import ListCampanha from '@pages/Private/Amex/shared/ListCampanhas';
import DetalhesCampanha from '@pages/Private/Amex/shared/DetalhesCampanha';
import ConfigEstrategia from '@pages/Private/Amex/shared/ConfigEstrategias';

import { AccountBoxIcon, BookMarkIcon, ContactPage, StickyNote2, Article, mdiDatabaseSearch } from '@src/Assets/Icons';
import DadosGeraisCadastros from '@src/Pages/Private/shared/Consultas';
import Financeiro from '@src/Pages/Private/Cliente/Admin/Financeiro';
import ImportarRetorno from '@src/Pages/Private/Cliente/Admin/ImportarRetorno';
import DetalhesRemessa from '@src/Pages/Private/Cliente/Admin/DetalhesRemessa';
import DetalhesHistoricoRemessa from '@src/Pages/Private/Cliente/Admin/DetalhesHistoricoRemessa';

import ListEstrategias from '@pages/Private/Cliente/Admin/ListEstrategias';
import DetalhesEstrategia from '@pages/Private/Cliente/Admin/DetalhesEstrategia';

import DashboardCadastros from '@src/Pages/Private/shared/Dashboard'
import InserirDoacoes from '@src/Pages/Private/Cliente/Admin/InsercaoDoacoes';
import NovoCadastro from '@src/Pages/Private/Cliente/shared/NovoCadastro';
import ListSolicitacoes from '@pages/Private/Cliente/Admin/ListSolicitacoes';
import TipoPerfil from '@pages/Private/Cliente/Admin/TiposPerfil';
import ListEnvios from '@pages/Private/Cliente/Admin/ListEnvios';
import ListCorrespondenciaDevolvida from '@src/Pages/Private/Cliente/Admin/CorrespondenciaDevolvida';
import ListaLigacao from '@pages/Private/Cliente/Operacional/ListaLigacao';
import Consultas from '@src/Pages/Private/shared/Consultas';
import HistoricoRemessa from '@pages/Private/Cliente/Admin/HistoricoRemessa';

//import DashboardCadastros from '@src/Pages/Private/shared/Dashboard'
//import Dashboard from '@src/Pages/Private/shared/DashboardG'
import DashboardComparativo from '@src/Pages/Private/shared/DashboardComparativo'
import TriagemCadastro from '@pages/Private/shared/Triagem/ListPessoas';
import EditCadastroTriagem from '@pages/Private/shared/Triagem/EditCadastro';

import {
  FavoriteBorderOutlined,
  PaymentOutlined,
  PieChartOutlined,
  LoyaltyOutlined,
  SendOutlined,
  PhoneInTalk,
  BarChart

} from '@material-ui/icons';


export interface IRoute {
  index: number | null;
  path: string;
  component: React.ComponentType<any>;
  roles: string[];
}
export interface IRouteMenu {
  index: number;
  path?: string;
  Icon?: React.ReactNode;
  label: string;
  roles: string[];
  menu: 'lateral' | 'header';
  subMenu?: IRouteMenu[];
}

export const routesAdmin: IRoute[] = [
  {
    index: 1,
    path: '/doacoes',
    component: DoacoesShared,
    roles: ['ADM AMEX'],
  },
  {
    index: 2,
    path: '/cadastros/consulta',
    component: ListPessoasShared,
    roles: ['ADM AMEX'],
  },
  {
    path: '/cadastro/:idCadastro',
    component: EditCadastro,
    roles: ['ADM AMEX'],
    index: null,
  },
  {
    index: 3,
    path: '/cadastros/novo',
    component: NovoCadastro,
    roles: ['ADM AMEX'],
  },
  {
    path: '/cadastros/dadosGerais',
    component: DadosGeraisCadastros,
    roles: ['ADM AMEX'],
    index: null,
  },
  {
    path: '/cadastros/indicadores',
    component: Indicadores,
    roles: ['ADM AMEX'],
    index: null,
  },
  {
    index: null,
    path: '/usuarios/',
    component: Usuarios,
    roles: ['ADM AMEX'],
  },
  {
    index: null,
    path: '/usuario/editar',
    component: EditarUsuario,
    roles: ['ADM AMEX'],
  },
  {
    index: null,
    path: '/campanha',
    component: ListCampanha,
    roles: ['ADM AMEX'],
  },
  {
    index: null,
    path: '/campanha/:idCampanha',
    component: DetalhesCampanha,
    roles: ['ADM AMEX'],
  },
  {
    index: null,
    path: '/estrategia/:idEstrategia',
    component: ConfigEstrategia,
    roles: ['ADM AMEX'],
  },
  {
    index: 8,
    path: '/financeiro',
    component: Financeiro,
    roles: ['ADM AMEX'],
  },
  {
    path: '/financeiro/gerarRemessa',
    component: Financeiro,
    roles: ['ADM AMEX'],
    index: null,
  },
  {
    path: '/financeiro/importarRetorno',
    component: ImportarRetorno,
    roles: ['ADM AMEX'],
    index: null,
  },
  {
    index: null,
    path: '/remessa/debito/detalhes',
    component: DetalhesRemessa,
    roles: ['ADM AMEX'],
  },
  {
    path: '/financeiro/historicoRemessa',
    component: HistoricoRemessa,
    roles: ['ADM AMEX'],
    index: null,
  },
  {
    index: null,
    path: '/historico/remessa/detalhes',
    component: DetalhesHistoricoRemessa,
    roles: ['ADM AMEX'],
  },
  {
    path: '/estrategias/',
    component: ListEstrategias,
    roles: ['ADM AMEX'],
    index: null,
  },
  {
    path: '/estrategias/:estrategiaID',
    component: DetalhesEstrategia,
    roles: ['ADM AMEX'],
    index: null,
  },
  {
    path: '/dashboard',
    component: DashboardCadastros,
    roles: ['ADM AMEX'],
    index: null,
  },
  {
    path: '/cadastros/solicitacoes',
    component: ListSolicitacoes,
    roles: ['ADM AMEX'],
    index: null,
  },
  {
    path: '/cadastros/tipo/perfil',
    component: TipoPerfil,
    roles: ['ADM AMEX'],
    index: null,
  },
  {
    index: null,
    path: '/inserir/doacoes',
    component: InserirDoacoes,
    roles: ['ADM AMEX'],
  },
  {
    index: null,
    path: '/envios',
    component: ListEnvios,
    roles: ['ADM AMEX'],
  },
  {
    index: null,
    path: '/correspondencia',
    component: ListCorrespondenciaDevolvida,
    roles: ['ADM AMEX'],
  },
  {
    path: '/ligacoes',
    component: ListaLigacao,
    roles: ['ADM AMEX'],
    index: null,
  },
  {
    path: '/consultas',
    component: Consultas,
    roles: ['ADM AMEX'],
    index: 9,
  },
  {
    path: '/dashboard/novos',
    component: DashboardCadastros,
    roles: ['ADM AMEX'],
    index: null,
  },
  {
    path: '/dashboard/comparativo',
    component: DashboardComparativo,
    roles: ['ADM AMEX'],
    index: null,
  },
  {
    index: null,
    path: '/cadastros/consulta/triagem',
    component: TriagemCadastro,
    roles: ['ADM AMEX'],
  },
  {
    path: '/cadastro/triagem/:idCadastro',
    component: EditCadastroTriagem,
    roles: ['ADM AMEX'],
    index: null,
  },
];

export const routesAdminMenu: IRouteMenu[] = [
  {
    index: 1,
    path: '/doacoes',
    label: 'Doações',
    Icon: <FavoriteBorderOutlined />,
    roles: ['ADM AMEX'],
    menu: 'header',
  },
  {
    index: 2,
    label: 'Cadastros',
    path: '/cadastros',
    Icon: ContactPage,
    roles: ['ADM AMEX'],
    menu: 'lateral',
    subMenu: [
      {
        index: 2.1,
        path: '/cadastros/novo',
        label: 'Novo',
        roles: ['ADM AMEX'],
        menu: 'lateral',
      },
      {
        index: 2.2,
        path: '/cadastros/consulta',
        label: 'Consulta',
        roles: ['ADM AMEX'],
        menu: 'lateral',
      },
      {
        index: 2.3,
        path: '/cadastros/solicitacoes',
        label: 'Solicitações',
        roles: ['ADM AMEX'],
        menu: 'lateral',
      },
      {
        index: 2.4,
        path: '/cadastros/tipo/perfil',
        label: 'Tipo de perfis',
        roles: ['ADM AMEX'],
        menu: 'lateral',
      },
      {
        index: 2.5,
        path: '/cadastros/indicadores',
        label: 'Indicadores',
        roles: ['ADM AMEX'],
        menu: 'lateral',
      },
      //{
       // index: 2.6,
        //path: '/cadastros/dadosGerais',
        //label: 'Dados Gerais',
        //roles: ['ADM AMEX'],
       // menu: 'lateral',
      //},
      {
        index: 2.7,
        path: '/cadastros/consulta/triagem',
        label: 'Consulta triagem',
        roles: ['ADM AMEX'],
        menu: 'lateral',
      },
    ],
  },
  {
    index: 3,
    label: 'Inserção de doações',
    path: '/inserir/doacoes',
    Icon: LoyaltyOutlined,
    roles: ['ADM AMEX'],
    menu: 'lateral',
  },
  {
    index: 4,
    label: 'Campanha',
    path: '/campanha',
    Icon: BookMarkIcon,
    roles: ['ADM AMEX'],
    menu: 'lateral',
  },
  {
    index: 5,
    label: 'Envios',
    path: '/envios',
    Icon: SendOutlined,
    roles: ['ADM AMEX'],
    menu: 'lateral',
  },
  {
    index: 6,
    label: 'Correspondência Devolvida',
    path: '/correspondencia',
    Icon: Article,
    roles: ['ADM AMEX'],
    menu: 'lateral',
  },
  {
    index: 7,
    label: 'Ligações',
    path: '/ligacoes',
    Icon: PhoneInTalk,
    roles: ['ADM AMEX'],
    menu: 'lateral',
  },
  {
    index: 8,
    path: '/estrategias/',
    label: 'Estratégias',
    Icon: <StickyNote2 />,
    roles: ['ADM AMEX'],
    menu: 'header',
  },
  {
    index: 9,
    path: '/consultas',
    label: 'Consultas',
    Icon: mdiDatabaseSearch,
    roles: ['ADM AMEX'],
    menu: 'lateral',
  },
  {
    index: 10,
    label: 'Financeiro',
    path: '/financeiro',
    Icon: PaymentOutlined,
    roles: ['ADM AMEX'],
    menu: 'lateral',
    subMenu: [
      // {
      //   index: 8.1,
      //   path: '',
      //   label: 'Emitir Boleto',
      //   roles: ['ADM AMEX'],
      //   menu: 'lateral',
      // },
      // {
      //   index: 8.2,
      //   path: '',
      //   label: 'Histórico de boleto',
      //   roles: ['ADM AMEX'],
      //   menu: 'lateral',
      // },
      {
        index: 10.3,
        path: '/financeiro/gerarRemessa',
        label: 'Gerar Remessa',
        roles: ['ADM AMEX'],
        menu: 'lateral',
      },
      // {
      //   index: 10.4,
      //   path: '',
      //   label: 'Histórico de remessa',
      //   roles: ['ADM AMEX'],
      //   menu: 'lateral',
      // },
      {
        index: 10.5,
        path: '/financeiro/importarRetorno',
        label: 'Importar retorno',
        roles: ['ADM AMEX'],
        menu: 'lateral',
      },
      // {
      //   index: 8.6,
      //   path: '',
      //   label: 'Histórico de arquivos',
      //   roles: ['ADM AMEX'],
      //   menu: 'lateral',
      // },
      {
        index: 10.6,
        path: '/financeiro/historicoRemessa',
        label: 'Histórico remessa',
        roles: ['ADM AMEX'],
        menu: 'lateral',
      },
    ],
  },
  {
    index: 11,
    label: 'Usuários',
    path: '/usuarios',
    Icon: AccountBoxIcon,
    roles: ['ADM AMEX'],
    menu: 'lateral',
  },




  {
    index: 12,
    label: 'Dashboard',
    Icon: BarChart,
    roles: ['ADM AMEX'],
    menu: 'lateral',
    subMenu: [
      {
        index: 12.1,
        path: '/dashboard/novos',
        label: 'Novos e Geral',
        roles: ['ADM AMEX'],
        menu: 'lateral',
      },
      {
        index: 12.2,
        path: '/dashboard/comparativo',
        label: 'Comparativo',
        roles: ['ADM AMEX'],
        menu: 'lateral',
      },
    ],
  },
];
